import React, {Component} from "react"
import {createTheme} from '@mui/material/styles';
import {HashRouter as Router, Redirect, Route, Switch} from 'react-router-dom'
import Logout from "./Auth/Logout";
import Clusters from "./Clusters";
import {connect} from "react-redux";
import {csrf_protection, get_user_info} from "../actions/auth";
import {switchMode} from "../actions/theming";
import Navbar from "./Custom/Navbar";
import {Box, Paper, StyledEngineProvider, ThemeProvider} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import './App.css';
import ChangePassword from "./Auth/ChangePassword";
import Cluster from "./Cluster";
import Test from "./Test";
import {TEST} from "../actions/test";
import Premium from "./Premium";
import PremiumOrder from "./PremiumOrder";
import Faq from "./Faq";
import Contact from "./Contact";
import Coupons from "./Coupons";
import Orders from "./Orders";
import Order from "./Order";
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import Auth from "./Auth";
import ProfileTermination from "./ProfileTermination";
import CheckPremiumTimer from "./CheckPremiumTimer";
import {get_premium_history} from "../actions/premium";
import {GoogleOAuthProvider} from "@react-oauth/google";
import CircularProgress from "@mui/material/CircularProgress";
import AIChat from "./Custom/AIChat";
import Settings from "./Settings";

Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: "https://a5cfb13eda1d4922bde54806d662d691@o919195.ingest.sentry.io/5863197",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

const lightTheme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#00ff00"
        },
        grey: {
            main: 'rgb(191, 191, 191)',
            contrastText: '#000'
        },
        secondary: {
            main: "#f50057"
        }
    },
    shadows: ["none"]
});
// https://stackoverflow.com/questions/39138380/how-to-apply-different-color-in-appbar-title-material-ui
const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#00ff00"
        },
        secondary: {
            main: "#f50057"
        },
        correct: {
            main: '#00ff00',
            contrastText: '#000'
        },
        wrong: {
            main: 'rgb(233,17,17)',
            contrastText: '#000'
        },
        grey: {
            main: 'rgb(191, 191, 191)',
            contrastText: '#000'
        },
        background: {
            paper: "#000000"
        }
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: "#00ff00",
                    color: "black"
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundImage: "none",
                },
                colorPrimary: {
                    backgroundColor: "#000000",
                    color: "white"
                }
            }
        }
    },
    shadows: Array(25).fill('none')
});

const styles = {
    footer: {
        textAlign: "center",
        position: "relative",
        //left: "0",
        //bottom: "0",
        width: "100%",
        borderRadius: 0,
        padding: "0 8px",
        boxSizing: "border-box",
        background: "none"
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "80px"
    }
}

class App extends Component {
    componentDidMount() {
        this.props.csrf_protection();
        if (this.props.auth.token && !this.props.auth.is_logged && !this.props.auth.is_waiting) {
            this.props.get_user_info();
            this.props.get_premium_history();
        }
    }

    render() {
        document.body.style.backgroundColor = this.props.theming.darkMode ? "black" : "white";
        document.body.style.color = this.props.theming.darkMode ? "white" : "black";

        const {classes} = this.props;
        let router;
        let footer = <Typography>
            © 2023 ED-Corporation<sup>TM</sup> via subsidiaries » All Rights Reserved » enjoy VOCA.CLICK with A. I.
            Teacher
        </Typography>

        if (this.props.auth.token && !this.props.auth.is_logged) {
            //router = <LinearProgress/>;
            return <StyledEngineProvider injectFirst>
                <ThemeProvider
                    theme={(this.props.theming.darkMode || !this.props.auth.is_logged) ? darkTheme : lightTheme}>
                    <div style={{height: "100vh", position: "relative"}}>
                        <div style={{height: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <CircularProgress style={{height: "15vh", width: "15vh"}}/>
                        </div>
                        <div style={{
                            display: "none",
                            position: "absolute",
                            bottom: 0,
                            width: "100%",
                            textAlign: "center"
                        }}>{footer}</div>
                    </div>
                </ThemeProvider></StyledEngineProvider>
        } else {
            if (this.props.auth.is_logged) {
                if (this.props.test.state === TEST.RUNNING) {
                    router = (
                        <Router>
                            <Navbar/>
                            <Switch>
                                <Route exact path="/logout" component={Logout}/>
                                <Route exact path="/clusters/:cluster_id/test" component={Test}/>
                                <Route
                                    render={() => <Redirect
                                        to={"/clusters/" + this.props.test.cluster_id + "/test"}/>}/>
                            </Switch>
                        </Router>
                    )
                } else {
                    router = (
                        <>
                            <Router>
                                <Navbar/>
                                <AIChat/>
                                <Switch>
                                    <Route exact path="/auth" render={() => <Redirect to="/auth/login"/>}/>
                                    <Route exact path="/login" render={() => <Redirect to="/auth/login"/>}/>
                                    <Route exact path="/registration"
                                           render={() => <Redirect to="/auth/registration"/>}/>
                                    <Route exact path="/forgot-password"
                                           render={() => <Redirect to="/auth/forgot-password"/>}/>
                                    <Route exact path="/reset-password"
                                           render={() => <Redirect to="/auth/reset-password"/>}/>
                                    <Route path="/auth" component={Auth}/>
                                    <Route path="/faq/:section" component={Faq}/>
                                    <Route path="/faq" component={Faq}/>
                                    <Route exact path="/contact" component={Contact}/>
                                    <Route exact path="/coupons" component={Coupons}/>
                                    <Route exact path="/settings" component={Settings}/>
                                    <Route exact path="/orders" component={Orders}/>
                                    <Route exact path="/orders/:order_id" component={Order}/>
                                    <Route exact path="/premium/buy/:type" component={PremiumOrder}/>
                                    <Route exact path="/premium" component={Premium}/>
                                    <Route exact path="/home" render={() => <Redirect to="/clusters"/>}/>
                                    <Route exact path="/logout" component={Logout}/>
                                    <Route exact path="/" render={() => <Redirect to="/clusters"/>}/>
                                    <Route exact path="/clusters/:cluster_id/test" component={Test}/>
                                    <Route exact path="/clusters/:cluster_id" component={Cluster}/>
                                    <Route exact path="/clusters" component={Clusters}/>
                                    <Route exact path="/change-password" component={ChangePassword}/>
                                    <Route exact path="/profile-termination" component={ProfileTermination}/>
                                    <Route render={() => <Redirect to="/clusters"/>}/>
                                </Switch>
                            </Router>
                        </>
                    )
                }
            } else {
                // todo presmerovanie z ktorejkolvek inej stranky ktora neni dostupna neautorizovanemu userovi
                router = (
                    <>
                        <Router>
                            <Switch>
                                <Route exact path="/login" render={() => <Redirect to="/auth/login"/>}/>
                                <Route exact path="/registration" render={() => <Redirect to="/auth/registration"/>}/>
                                <Route exact path="/forgot-password"
                                       render={() => <Redirect to="/auth/forgot-password"/>}/>
                                <Route exact path="/reset-password"
                                       render={() => <Redirect to="/auth/reset-password"/>}/>
                                <Route exact path="/auth" render={() => <Redirect to="/auth/login"/>}/>
                                <Route path="/auth" component={Auth}/>
                                <Route exact path="/logout" component={Logout}/>
                                <Route exact path="/clusters/:cluster_id" render={() => <Redirect to="/auth/login"/>}/>
                                <Route exact path="/clusters/:cluster_id/test"
                                       render={() => <Redirect to="/auth/login"/>}/>
                                <Route exact path="/clusters" render={() => <Redirect to="/auth/login"/>}/>
                                <Route exact path="/home" render={() => <Redirect to="/auth/login"/>}/>
                                <Route exact path="/" render={() => <Redirect to="/auth/login"/>}/>
                                <Route render={() => <Redirect to="/auth/login"/>}/>
                            </Switch>
                        </Router>
                    </>

                )
            }
        }
        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider
                    theme={(this.props.theming.darkMode || !this.props.auth.is_logged) ? darkTheme : lightTheme}>
                    <GoogleOAuthProvider
                        clientId="183543105985-i9e1htanv4grjndeiam1m4ger8b7booc.apps.googleusercontent.com">
                        <Box elevation={0}  /* TODO square */>
                            {router}
                            <Paper className={classes.footer} elevation={0} /* TODO square */>
                                {footer}
                            </Paper>
                            {/*<SwitchMat*/}
                            {/*    className={classes.darkModeSwitch}*/}
                            {/*    checked={this.props.theming.darkMode}*/}
                            {/*    onChange={this.props.switchMode}*/}
                            {/*    style={{color: "black"}}*/}
                            {/*    name="darkModeSwitch"*/}
                            {/*    inputProps={{ 'aria-label': 'secondary checkbox' }}*/}
                            {/*/>*/}
                            {this.props.premium.history !== null && this.props.premium.history.length > 0 && this.props.premium.history[0].payments.length > 0 && this.props.premium.history[0].payments[0].current_state === "UNTRUSTED_PAID" &&
                                <CheckPremiumTimer/>}

                        </Box>
                    </GoogleOAuthProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    test: state.test,
    theming: state.theming,
    premium: state.premium
});

export default withStyles(styles)(connect(
    mapStateToProps,
    {get_user_info, csrf_protection, switchMode, get_premium_history}
)(App));
